import React from 'react';
import {
    FaMapMarkerAlt, FaQuoteRight, FaHeartbeat, FaUserCircle
} from 'react-icons/fa';
import './ResearcherProfileView.css'; // Reusing base styles for modal consistency

const PatientProfileView = ({ patient }) => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

    const profile = patient?.profile || {};
    const fullName = `${profile.firstName || ''} ${profile.lastName || ''}`.trim() || patient?.name || 'Paciente';
    const bio = profile.bio || 'Este usuario aún no ha añadido una biografía a su perfil.';

    // Resolver URL de imagen
    const photoUrl = profile.photoUrl
        ? (profile.photoUrl.startsWith('http') ? profile.photoUrl : `${backendUrl.replace('/api', '')}${profile.photoUrl}`)
        : patient?.img;

    const initials = (profile.firstName?.charAt(0) || '') + (profile.lastName?.charAt(0) || '') || fullName.charAt(0);

    return (
        <div className="rpv-container">
            <div className="rpv-header">
                <div className="rpv-avatar-large">
                    {photoUrl ? (
                        <img src={photoUrl} alt={fullName} style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
                    ) : (
                        <div className="rpv-initials-placeholder">{initials}</div>
                    )}
                </div>
                <div className="rpv-header-info">
                    <h1>{fullName}</h1>
                    <p className="rpv-role">Comunidad Paciente</p>
                    <div className="rpv-meta-row">
                        <span><FaMapMarkerAlt /> {profile.country || 'Ubicación no especificada'}</span>
                        <span><FaHeartbeat /> Paciente Activo</span>
                    </div>
                </div>
            </div>

            <div className="rpv-content">
                <div className="rpv-main">
                    <section className="rpv-section">
                        <h2><FaQuoteRight style={{ fontSize: '0.8em', opacity: 0.5, marginRight: '8px' }} /> Sobre mí</h2>
                        <p className="rpv-bio">{bio}</p>
                    </section>

                    <section className="rpv-section">
                        <h2>Información Adicional</h2>
                        <div className="rpv-list">
                            <div className="rpv-item">
                                <div className="rpv-item-icon"><FaUserCircle /></div>
                                <div className="rpv-item-content">
                                    <h4>Intereses y Bienestar</h4>
                                    <p>Conectado con la comunidad para compartir experiencias y mejorar la salud conjunta.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PatientProfileView;
